var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"flex-center"},[_c('beat-loader',{attrs:{"loading":_vm.loading,"color":"#C1006D"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }